<template>
	<div class="app flex-row align-items-center">
		<div class="container-fluid">
            <div class="client-app-inc" style="height:200px" v-if="loading">
                <Loader></Loader>
            </div>
			<slot v-if="!loading">
                <div v-if="is_script" v-html-js="{html: game_data, script:'javascript'}"></div>
                <iframe id="bcsportsbookcontainer" v-if="!is_script" :src="game_url" style="height:1000px" frameborder="0" width="100%"/>
            </slot>
		</div>
	</div>
</template>
<style>
    #app.mobile #bcsportsbookcontainer {
        height: var(--mobileHeight) !important;
    }
</style>
<script>
    export default {
        name: 'Sportsbook',
        data: function() {
            return {
                loading: false,
                game_url: null,
                game_data: null,
                is_script: false,
            }
        },
        created: function () {
            this.fetchData();
            if(this.isMobile){
                document.querySelector("body").style.setProperty('--mobileHeight', window.innerHeight - 60 + 'px');
            }
        },

        methods: {
            fetchData: function() {
                this.loading = true;
                axios.get('/sportsbook', { params: { mobile : this.isMobile }})
                .then((response)=>{
                    this.loading = false;
                    this.is_script = response.data.config.is_script
                    if(this.is_script){
                        this.game_data = response.data.data
                    }else{
                        this.game_url = response.data.config.url
                    }   
                })
                .catch((err)=>{
                });

            },

        }
    }
</script>